<template>
  <div class="box">
    <!-- Filters -->
    <div class="filters-row mb-3 p-4">
      <div class="filter-group">
        <div class="form-group">
          <label for="booking_ref" class="form-label">Booking Reference</label>
          <input type="text"
            class="form-control" 
            name="booking_ref" id="booking_ref" 
            placeholder="Booking Reference"
            v-model="filters.booking_ref">
        </div>
      </div>
      <div class="filter-group">
        <label>Event</label>
        <v-select
          v-model="filters.event"
          :options="events"
        />
      </div>
      <div class="filter-group">
        <label> Start Date </label>
        <dateTimePicker
          no-label
          label="Start Date"
          id="log-start-date"
          button-color="#ec391e"
          color="#ec391e"
          :only-date="true"
          v-model="filters.start"
          style="border: 1px solid #DFE5F9"
        />
      </div>
      <div class="filter-group">
        <label> End Date </label>
        <dateTimePicker
          no-label
          label="End Date"
          id="log-end-date"
          button-color="#ec391e"
          color="#ec391e"
          :only-date="true"
          v-model="filters.end"
          style="border: 1px solid #DFE5F9"
        />
      </div>
      <div class="filter-group">
        <label>Recipient Email</label>
        <input type="text" v-model="filters.recipient" placeholder="Filter by recipient..." />
      </div>
      <div class="mt-4">
        <button class="button button--small" @click="doSearch"> Filters Logs</button>
        <button class="button button--small" @click="resetFilters">
          <span class="icon icon--reload"></span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <!-- Table -->
        <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="options"
            :key="tableKey"
        />
      </div>
    </div>
</div>
</template>

<script>
import 'datatables.net'
import moment from 'moment'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'LogEntriesTable',
  components: {
    VdtnetTable
  },
  data() {
    return {
      events: ['accepted', 'delivered', 'failed', 'opened', 'clicked', 'unsubscribed', 'complained'],
      tableKey: 0, 
      options: {
        ajax: {
          url: this.$api + 'mailgun/filter',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          },
          // Show loading state on every AJAX request
          beforeSend: () => {
            this.$store.dispatch('setLoadStatus')
          },
          // Hide loading state when AJAX completes
          complete: () => {
            this.$store.dispatch('setLoadStatus')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
      },
      fields: {
        occurred_at: {
          label: 'Timestamp',
          render: (data, type, row) => {
           return `${ this.$options.filters.formatDateTime(data)}`
          }
        },
        event: {
          label: 'Event',
          render: (data, type, row) => {
            let badgeClass = '';
            let severityClass = '';
            switch(data) {
              case 'accepted':
                badgeClass = 'badge--accepted';
                break;
              case 'delivered':
                badgeClass = 'badge--delivered';
                break;
              case 'failed':
                badgeClass = 'badge--failed';
                break;
              default:
                badgeClass = 'badge--default';
            }
            switch(row.severity) {
              case 'temporary':
                severityClass = 'badge--temporary-failed';
                break;
              case 'permanent':
                severityClass = 'badge--permanent-failed';
                break;
              default:
                severityClass = 'badge--default';
            }
            return `<span class="badge ${badgeClass}">${data}</span> ${(row.severity) ? `| <span class="badge ${severityClass}">${row.severity}</span>` : ''}`;
          },
        },
        recipient: { label: 'Recipient' },
        booking_history: {
          label: 'Booking',
          render: (data, type, row) => {
            if (data) {
              return `<a href="/bookings/edit/${data.booking.id}" target="_blank" class="button button--small button--info">
                        <span class="icon icon--details"></span> ${data.booking.booking_ref}
                      </a>`;
            }
            return 'N/A';
          }
        }
      },
      filters: {
        filter_start: '',
        filter_end: '',
        recipient: '',
        event: '',
        booking_ref: ''
      },
    };
  },
  computed: {
    
  },
  methods: {
    doSearch() {
      const ajaxUrl = this.$api + 'mailgun/filter'
      const queryString = new URLSearchParams();
      
      if(this.filters.booking_ref){
        queryString.set('booking_ref', this.filters.booking_ref);
      }

      if(this.filters.filter_start && this.filters.filter_end){
        queryString.set('filter_start', this.filters.filter_start);
        queryString.set('filter_end', this.filters.filter_end);
      }

      if(this.filters.recipient){
        queryString.set('recipient', this.filters.recipient);
      }

      if(this.filters.event){
        queryString.set('event', this.filters.event);
      }
      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.tableKey++;

    },
    formatted(payload) {
      try {
        return JSON.stringify(JSON.parse(payload), null, 2);
      } catch (e) {
        return payload; // fallback if already formatted string
      }
    },
    resetFilters() {
      this.filters = {
        filter_start: '',
        filter_end: '',
        recipient: '',
        event: '',
        booking_ref: ''
      };
      this.doSearch();
    },
    resendEmail(id, encryptedData) {
      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}mailgun/resend`, {
        method: 'POST',
        body: JSON.stringify({
          id,
          email_token: encryptedData
        }),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then((res) => {
        if (res.status) {
          this.$toast.success('Email resend initiated successfully.');
        } else {
          this.$toast.error(res.message || 'Failed to initiate email resend.');
        }
        this.$store.dispatch('setLoadStatus')
      })
      .catch(() => {
        this.$toast.error('An error occurred while trying to resend the email.');
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
};
</script>

<style>
/* Filter row layout */
.filters-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.filter-group {
  flex: 1 1 180px;
  min-width: 160px;
  display: flex;
  flex-direction: column;
}
.filter-group label {
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.filter-group input[type="date"],
.filter-group input[type="text"] {
  padding: 0.5em 0.75em;
  border: 1px solid #dfe5f9;
  border-radius: 0.25rem;
  font-size: 1em;
}
.filter-group--button {
  display: flex;
  align-items: flex-end;
}

.details {
  background: #1e1e1e;       /* dark background */
  color: #d4d4d4;            /* default code text */
  padding: 12px;
  border-radius: 6px;
  font-family: 'Fira Code', monospace;
  font-size: 13px;
  line-height: 1.5;
  overflow-x: auto;
}

.details pre {
  margin: 0;
}

.details code.json {
  color: #d4d4d4;
}

/* Optional syntax highlighting */
.details code.json .string { color: #ce9178; }
.details code.json .number { color: #b5cea8; }
.details code.json .boolean { color: #569cd6; }
.details code.json .null { color: #569cd6; }
.details code.json .key { color: #9cdcfe; }

</style>
